import { useNavigate } from "react-router-dom";
import { useChatSidebarStore } from "../../stores/chatSidebarStore";
import { getPathForPhase } from "./pagePhaseMap";
import type { JourneyPhaseKind } from "./types";

// Single place that both activates a journey phase in the sidebar and
// routes to that phase's page, so every affordance that lets the user jump
// to a phase (the in-chat switcher, the page-match banner, ...) behaves the
// same way.
export function useSwitchJourneyPhase() {
  const openChat = useChatSidebarStore((s) => s.openChat);
  const navigate = useNavigate();

  return (kind: JourneyPhaseKind) => {
    openChat({ mode: kind });
    const path = getPathForPhase(kind);
    if (path) navigate(path);
  };
}
